module.exports = __webpack_public_path__ + "img/fracais.11de5eda.svg";